import { useReducedMotion } from 'framer-motion';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';

import Divider from '@zenbusiness/zui/Divider';

import AppHeader from '#client/components/AppHeader';

import * as Styled from './ArticleOverlay.style';
import { articleMarkdownComponents } from '../utils/markdownComponents';

const overlayVariants = {
  hidden: {
    opacity: 0,
    y: 40
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 30,
      mass: 0.8
    }
  },
  exit: {
    opacity: 0,
    y: -80,
    transition: {
      type: 'spring',
      stiffness: 400,
      damping: 25,
      mass: 0.6
    }
  }
};

export default function ArticleOverlay({ article, onClose }) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <Styled.ArticleOverlayRoot
      animate={prefersReducedMotion ? undefined : 'visible'}
      exit={prefersReducedMotion ? undefined : 'exit'}
      initial={prefersReducedMotion ? false : 'hidden'}
      variants={overlayVariants}
    >
      <AppHeader title={article.title} onBack={onClose} />
      <Styled.ArticleOverlayContainer>
        <Styled.ArticleOverlayImage alt={article.title} src={article.imageUrl} />
        <Styled.ArticleOverlayTitle size="2xl" weight="bold">
          {article.title}
        </Styled.ArticleOverlayTitle>
        <Divider />
        <Styled.Summary color="tertiary" size="xs">
          SUMMARY
        </Styled.Summary>
        <Styled.ArticleOverlaySummary size="sm">{article.summary}</Styled.ArticleOverlaySummary>
        <Divider />
        <Styled.ArticleOverlayContent>
          <ReactMarkdown components={articleMarkdownComponents} rehypePlugins={[rehypeRaw]}>
            {article.markdown}
          </ReactMarkdown>
        </Styled.ArticleOverlayContent>
      </Styled.ArticleOverlayContainer>
    </Styled.ArticleOverlayRoot>
  );
}

ArticleOverlay.propTypes = {
  article: PropTypes.shape({
    title: PropTypes.string,
    imageUrl: PropTypes.string,
    description: PropTypes.string,
    markdown: PropTypes.string,
    summary: PropTypes.string
  }),
  onClose: PropTypes.func.isRequired
};
